interface Props {
	title: string;
	description?: string;
}

const PageHeader = (props: Props): JSX.Element => {
	const { title, description } = props;

	return (
		<div className="py-6 lg:py-5 md:py-4 sm:py-3">
			<h1 className="text-3xl lg:text-[28px] md:text-2xl sm:text-[22px] font-bold text-foreground m-0 mb-2 md:mb-1.5 leading-tight">
				{title}
			</h1>
			{description && (
				<p className="text-base md:text-[15px] sm:text-sm text-muted-foreground m-0 leading-relaxed font-normal">
					{description}
				</p>
			)}
		</div>
	);
};

export default PageHeader;
